module.exports = __webpack_public_path__ + "img/calendario.11819a73.png";